import { ResponsiveContainer, styled } from '@arpeggi/ui'
import { FC } from 'react'
import { ChevronLeft } from '../../../__legacy__/components/core/icons'

const Root = styled(ResponsiveContainer, {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '48px'
})

const StyledBackButton = styled('button', {
  all: 'unset',
  background: '$whiteA800',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '32px',
  height: '32px',
  borderRadius: '9999px',
  color: '$black',
  overflow: 'hidden',
  '&:hover': {
    background: '$white'
  },
  '&:active': {
    background: '$whiteA500'
  }
})

const BackButton: FC = () => {
  return (
    <StyledBackButton onClick={() => history.back()}>
      <ChevronLeft />
    </StyledBackButton>
  )
}

export const TopNav = { Root, BackButton }
